import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AuthGuard } from './shared/guard/auth.guard';

export const AppRoutes: Routes = [
    // {
    //     path: '',
    //     canActivate: [AuthGuard],
    //     component: AdminLayoutComponent,
    //     children: [
    //       {
    //         path: '',
    //         loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule)
    //       },
    //     ]
    // }, 
      // {
      //   path: '',
      //   redirectTo: '/login',
      //   pathMatch: 'full',
      // },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [{
            path: '',
            loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
        }]
    },

];
